import type {
  LinhaEstrutura,
  TipoObraBase,
  VisaoEscopoPadrao,
} from "@/modules/financeiro-configuracoes";
import { TIPOS_OBRA_POR_VISAO } from "./escopos-padrao.constants";
import type { EscoposPadraoOpcao } from "./types-escopos-padrao";

export function tiposDaVisao(
  tipos: readonly TipoObraBase[],
  visao: VisaoEscopoPadrao,
): EscoposPadraoOpcao[] {
  return tipos
    .filter(
      (tipo) => tipo.situacao === "ATIVO" && TIPOS_OBRA_POR_VISAO[visao].includes(tipo.codigo),
    )
    .map((tipo) => ({ label: `${tipo.codigo} · ${tipo.nome}`, value: tipo.id }));
}

export function gruposDaVisao(
  estrutura: readonly LinhaEstrutura[],
  visao: VisaoEscopoPadrao,
  tipoObraId: string,
): EscoposPadraoOpcao[] {
  if (visao === "OUTROS") return [];
  const vistos = new Map<string, string>();
  for (const linha of estrutura) {
    if (linha.grupoSituacao !== "ATIVO") continue;
    if (!TIPOS_OBRA_POR_VISAO[visao].includes(linha.tipoObraCodigo)) continue;
    if (tipoObraId && linha.tipoObraId !== tipoObraId) continue;
    vistos.set(linha.grupoId, linha.grupoNome);
  }
  return [...vistos].map(([value, label]) => ({ label, value }));
}
